export const LICENSE_STATES = {
    ACTIVE: 0,
    CANCELLED: 1,
    ALMOST_EXPIRED: 2,
    EXPIRED: 3,
};

export function getLicenseStateConfig(t) {
    return {
        [LICENSE_STATES.ACTIVE]: { label: t('mod_budgets_license_state_active'), class: 'bg-success text-white' },
        [LICENSE_STATES.CANCELLED]: { label: t('mod_budgets_license_state_cancelled'), class: 'bg-secondary text-white' },
        [LICENSE_STATES.ALMOST_EXPIRED]: { label: t('mod_budgets_license_state_almost_expired'), class: 'bg-warning text-gray' },
        [LICENSE_STATES.EXPIRED]: { label: t('mod_budgets_license_state_expired'), class: 'bg-danger text-white' },
    };
}

export function getLicenseActions(license, licenseType) {
    const isDemo = licenseType?.isDemo;
    const { status } = license;
    return {
        canRenew: !isDemo && (status === LICENSE_STATES.EXPIRED || status === LICENSE_STATES.ALMOST_EXPIRED),
        canReactivate: !isDemo && status === LICENSE_STATES.CANCELLED,
        canCancel: status !== LICENSE_STATES.CANCELLED && !!licenseType && licenseType.typeDuration === 0,
    };
}

export function hasLicenseActions(license, licenseType) {
    return Object.values(getLicenseActions(license, licenseType)).some(Boolean);
}
